// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_SummaryQrCodeRequest } from "@newgenerated/shared/serializerDeserializer/SummaryQrCodeRequest";
import { deserialize_SummaryQrCodeResponse } from "@newgenerated/shared/serializerDeserializer/SummaryQrCodeResponse";

export async function getSummaryShareQrCode(props: { body: schema.SummaryQrCodeRequest }): Promise<ApiResult<schema.SummaryQrCodeResponse>> {
  const path = "/gaapi/summary/qrcode";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_SummaryQrCodeRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.SummaryQrCodeResponse> => {
    return deserialize_SummaryQrCodeResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
